import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import getDate from '../../helpers/date';

import './DraftChangeStatus.pcss';

const DraftChangeStatus = ({ draftDate, draftLoading, draftError }) => {
  const [date, setDate] = useState(null);

  useEffect(() => {
    setDate(draftDate);
  }, [draftDate]);

  return (
    <div className="DraftChangeStatus">
      {draftLoading === false && draftError === false && draftDate ? (
        <p>Изменения автоматически сохранены {getDate(date, true)}</p>
      ) : null}
      {(draftLoading === null || draftError === false) &&
      (draftError === null || draftError === false) &&
      draftDate === null ? (
        <p>Изменения сохраняются автоматически</p>
      ) : null}
      {draftLoading === false && draftError === true ? (
        <p>Изменения не сохранены</p>
      ) : null}
    </div>
  );
};

DraftChangeStatus.propTypes = {
  draftDate: PropTypes.number,
  draftLoading: PropTypes.bool,
  draftError: PropTypes.bool
};

DraftChangeStatus.defaultProps = {
  draftDate: null,
  draftLoading: null,
  draftError: null
};

export default DraftChangeStatus;
